import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, Switch, Route, Redirect } from 'react-router-dom'

import { useShallowEqualSelector } from 'custom-hooks/useShallowEqualSelector'
import Logo from 'components/Logo/Logo'
import Link from 'components/CommonUI/Link/Link'
import ContentContainer from './components/ContentContainer'
import TermPrivacyLinks from './components/TermPrivacyLinks'
import LoginForm from './components/LoginForm'
import Spinner from 'components/CommonUI/Spinner/Spinner'
import AlertStyled from 'components/CommonUI/Alert/Alert'
import RecoveryPasswordForm from './components/RecoveryPasswordForm'
import RecoveryPasswordSentEmail from './components/RecoveryPasswordSentEmail'
import HandleRestoreLink from './components/HandleRestoreLink'
import ComfirmRestorePassword from './components/ComfirmRestorePassword'
import ErrorResetPassword from './components/ErrorResetPassword'
import SuccessRestorePassword from './components/SuccessRestorePassword'
import {
  getIsAuthSelector,
  getIsFetchingSelector,
  getIsSuccessResporePassword,
  getRedirectAfterLogoutSelector,
  clearRedirectAfterLogout,
  getProfileGroupsSelector,
} from 'redux/reducers/profile'
import { getIsShowNotificationSelector } from 'redux/reducers/notification'
import { routingConstants } from 'constants/routingConstants'

const AuthPage = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const isAuth = useShallowEqualSelector(getIsAuthSelector)
  const isFetching = useShallowEqualSelector(getIsFetchingSelector)
  const isShowAlert = useShallowEqualSelector(getIsShowNotificationSelector)
  const isSuccessRestorePassword = useShallowEqualSelector(
    getIsSuccessResporePassword
  )
  const redirectAfterLogout = useShallowEqualSelector(
    getRedirectAfterLogoutSelector
  )

  const [firstGroup] = useShallowEqualSelector(getProfileGroupsSelector)

  useEffect(() => {
    if (isAuth) {
      history.push(`${routingConstants.overview}/${firstGroup?.id}`)
    }
  }, [history, isAuth, firstGroup])

  useEffect(() => {
    if (redirectAfterLogout) {
      history.push(redirectAfterLogout)
    }
    return () => {
      dispatch(clearRedirectAfterLogout())
    }
  }, [redirectAfterLogout, history, dispatch])

  return (
    <div className="auth_page_container">
      <div className="blur_wrap">
        {!isSuccessRestorePassword && (
          <Link to={'/'}>
            <Logo className="auth_page_logo" isWhite />
          </Link>
        )}
        <Switch>
          <Route path={routingConstants.recoveryPassword} exact>
            <ContentContainer withBack className="recovery_password">
              <RecoveryPasswordForm />
            </ContentContainer>
          </Route>
          <Route path={routingConstants.recoveryPasswordSentEmail} exact>
            <ContentContainer withBack className="recovery_password">
              <RecoveryPasswordSentEmail />
            </ContentContainer>
          </Route>
          <Route path={routingConstants.confirmRestoreCode} exact>
            <HandleRestoreLink />
          </Route>
          <Route path={routingConstants.confirmRestorePassword} exact>
            <ContentContainer>
              <ComfirmRestorePassword />
            </ContentContainer>
          </Route>
          <Route path={routingConstants.errorRestorePassword} exact>
            <ContentContainer withBack className="recovery_password">
              <ErrorResetPassword />
            </ContentContainer>
          </Route>
          <Route path={routingConstants.successRestorePassword} exact>
            <SuccessRestorePassword />
          </Route>
          <Route path={routingConstants.auth} exact>
            <ContentContainer>
              <LoginForm />
            </ContentContainer>
          </Route>
          <Redirect to={routingConstants.auth} />
        </Switch>

        {!isSuccessRestorePassword && <TermPrivacyLinks />}
        {isFetching && <Spinner />}
        {isShowAlert && <AlertStyled />}
      </div>
    </div>
  )
}

export default AuthPage
